import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Product } from '@core/model/product.model';
import { Warehouse } from '@core/model/warehouse.model';
import { ProductService, WarehouseService } from '@app/core';
import Swal from 'sweetalert2';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { WarehouseCreateComponent } from '@app/dashboard/warehouse/warehouse-create/warehouse-create.component';
import { Paginated } from '@app/core/model/paginated.model';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-warehouse-list',
  templateUrl: './warehouse-list.component.html',
  styleUrls: ['./warehouse-list.component.css']
})
export class WarehouseListComponent implements OnInit {
  warehouseForm: FormGroup;
  products: Product[];
  warehouses: Warehouse[];

  pager = {};
  pageOfItems: any = [];

  almacen: Paginated;
  paginanum: number;

  private searchTermStream = new Subject<string>();
  currentSearchTerm: string = null;
  private closeResult: string;
  private moldaOptions: NgbModalOptions = {
    size: 'lg',
    backdrop: 'static',
    backdropClass: 'customBackdrop'
  };

  constructor(
    private formBuilder: FormBuilder,
    private productService: ProductService,
    public warehouseService: WarehouseService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.createForm();
    this.listProducts();

    this.warehouseService
      .getAlmacen()
      .then(almacen => (this.almacen = almacen));

    this.searchTermStream.subscribe((term: string) => {
      this.warehouseService.search(term).then((almacen: any) => {
        this.currentSearchTerm = term;
        this.updateAlmacen(almacen);
        console.log('prueba', almacen);
      });
    });
  }

  updateAlmacen(almacen: Paginated) {
    const almacenWithUpdatedNavs = this.updateNavUrls(
      this.currentSearchTerm,
      almacen
    );
    this.almacen = almacenWithUpdatedNavs;
  }
  updateNavUrls(term: string, almacen: Paginated): Paginated {
    if (term) {
      if (almacen.prev_page_url) {
        almacen.prev_page_url += `&term=${term}`;
      }
      if (almacen.next_page_url) {
        almacen.next_page_url += `&term=${term}`;
      }
    }
    return almacen;
  }

  prevPage() {
    this.warehouseService
      .getAlmacenAtUrl(this.almacen.prev_page_url)
      .then((almacen: any) => {
        this.updateAlmacen(almacen);
      });
  }

  nextPage() {
    this.warehouseService
      .getAlmacenAtUrl(this.almacen.next_page_url)
      .then((almacen: any) => {
        this.updateAlmacen(almacen);
      });
  }

  search(term: string) {
    this.searchTermStream.next(term);
  }
  searchPage(value: number) {
    this.warehouseService.getAlmacenAtUrl2(value).then((almacen: any) => {
      this.updateAlmacen(almacen);
    });
  }
  createForm() {
    this.warehouseForm = this.formBuilder.group({
      cantidad: ['', [Validators.required]],
      fecha_ingreso: [
        new Date().toISOString().substring(0, 10),
        [Validators.required]
      ],
      precio_compra: ['', [Validators.required]],
      precio_venta: ['', [Validators.required]],
      producto_id: ['', [Validators.required]]
    });
  }

  listProducts() {
    this.productService.getProductosAlmacen().subscribe(
      date => {
        this.products = date;
        console.log(date);
      },
      error1 => {
        console.log(error1.error);
      }
    );
  }

  listWarehouse() {
    this.warehouseService.getAll().subscribe(
      data => {
        this.warehouses = data;
        console.log('PRUEBA', data);
      },
      error => {
        console.log(error.error);
      }
    );
  }

  registerWarehouse() {
    const newWareHouse = new Warehouse();
    console.log(this.warehouseForm.value);
    newWareHouse.cantidad = this.warehouseForm.value.cantidad;
    newWareHouse.fecha_ingreso = this.warehouseForm.value.fecha_ingreso;
    newWareHouse.precio_compra = this.warehouseForm.value.precio_compra;
    newWareHouse.precio_venta = this.warehouseForm.value.precio_venta;
    newWareHouse.producto_id = this.warehouseForm.value.producto_id;

    this.warehouseService.create(newWareHouse).subscribe(
      data => {
        console.log(data);
        Swal.fire(data);
        this.warehouseForm.reset();
        this.listWarehouse();
      },
      error => {
        Swal.fire(error);
        console.log(error.error);
      }
    );
  }

  createWarehouse() {
    const modal = this.modalService.open(
      WarehouseCreateComponent,
      this.moldaOptions
    );
    modal.result.then(result => {
      if (result) {
        this.warehouseService
          .getAlmacen()
          .then(almacen => (this.almacen = almacen));

        console.log(this.almacen);

        this.searchTermStream.subscribe((term: string) => {
          this.warehouseService.search(term).then((almacen: any) => {
            this.currentSearchTerm = term;
            this.updateAlmacen(almacen);
          });
        });
      }
    });
  }
  editModal(id: number) {
    const modal = this.modalService.open(
      WarehouseCreateComponent,
      this.moldaOptions
    );
    modal.componentInstance.almacen_id = id;
    modal.componentInstance.estado = true;
    modal.componentInstance.titulo = 'Editar Almacen';
    modal.result.then(result => {
      if (result) {
        this.warehouseService
          .getAlmacen()
          .then(almacen => (this.almacen = almacen));

        console.log(this.almacen);

        this.searchTermStream.subscribe((term: string) => {
          this.warehouseService.search(term).then((almacen: any) => {
            this.currentSearchTerm = term;
            this.updateAlmacen(almacen);
          });
        });
      }
    });
  }

  eliminar(id: string) {
    Swal.fire({
      title: 'Esta seguro de Eliminar el ingreso?',
      text: 'Una vez eliminado, Ud no podra recuperar el ingreso eliminado!',
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then(willDelete => {
      if (willDelete.value) {
        this.warehouseService.delete(id).subscribe(
          data => {
            this.warehouseService
              .getAlmacen()
              .then(almacen => (this.almacen = almacen));

            // this.warehouses = data;

            this.searchTermStream.subscribe((term: string) => {
              this.warehouseService.search(term).then((almacen: any) => {
                this.currentSearchTerm = term;
                this.updateAlmacen(almacen);
              });
            });
            Swal.fire(data);
          },
          error => {
            console.log(error.error);
          }
        );
      } else {
        Swal.fire('No se pudo eliminar');
      }

      console.log(willDelete);
    });
  }
}
